"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TaxonomyGroup = /** @class */ (function () {
    function TaxonomyGroup(system, terms) {
        this.system = system;
        this.terms = terms;
    }
    return TaxonomyGroup;
}());
exports.TaxonomyGroup = TaxonomyGroup;
//# sourceMappingURL=taxonomy-group.class.js.map